var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.822 16.8136C12.4243 17.3876 11.5757 17.3876 11.178 16.8136L5.29315 8.31949C4.83367 7.65629 5.30833 6.75 6.11514 6.75L17.8849 6.75C18.6917 6.75 19.1663 7.65629 18.7069 8.3195L12.822 16.8136Z",
    fill: "#D92F22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownRed);
export default __webpack_public_path__ + "static/media/DownRed.b3d124293e40f4888ff210d8bda283b9.svg";
export { ForwardRef as ReactComponent };